module.exports = __webpack_public_path__ + "media/educators/ClickToContactUs5-a9b21479.png";